<template>
<div id="profile" class="profile profile-edit">

  <h1 class="heading-common is-btn-back"><a class="btn-back" @click="back"></a> {{ $t('password.title') }}</h1>

  <!-- Container -->
    <section class="container">
    <div class="row">

      <edit-password-form @updateSuccess="updateSuccess"></edit-password-form>

    </div>
  </section>
    <!-- /Container -->

</div>
</template>

<script>
  import EditPasswordForm from './EditPasswordForm.vue'

  export default {
    components: {
      'edit-password-form': EditPasswordForm
    },
    methods: {
      updateSuccess() {
        this.$router.push({name: 'profile', params: { success_message: this.$i18n.t('password.success') }});
      },
      back() {
        this.$router.push({name: 'profile'});
      }
    }
  }
</script>


<style lang="scss" scoped>
#profile {
  h2 {
  font-weight: bold;
    font-size: 23px;
    line-height: 41px;
    border-bottom: 1px solid #eeeeee;
    padding: 15px;
    color: #686868;
  }

}

@media screen and (min-width: 768px) {
  .main-center {
    width: 100%;
    max-width: 1036px;
    margin: 0 auto;
  }
}

</style>
